import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Row } from 'reactstrap';

class PersonifySecurity extends Component {
  state = {}

  render() {
    return (
      <div className="page-personify narrow">
        <Container>
          <Row className="mb-3 mt-2">
            <Col className="text-center">
              <h2 className="mb-2">For your security, we need to verify your identity</h2>
              <p>Records indicate that the below contact information is associated with (First Name) (Last Name). Please select a phone number to a device you have access to right now, and then a delivery method. We will send a temporary identification number to enter on the next screen.</p>
            </Col>
          </Row>
          <Form>
            <Row>
              <Col md={6}>
                <Card>
                  <CardHeader>Contact Phone</CardHeader>
                  <CardBody>
                    <FormGroup className="mb-3">
                      <CustomInput type="radio" id="exampleCustomRadio" name="customRadio" label="XXX-XXX-5701" />
                      <CustomInput type="radio" id="exampleCustomRadio2" name="customRadio" label="XXX-XXX-2977" />
                    </FormGroup>
                    <small><strong>Don't have access to these phone numbers?</strong><br />
                    <a href="/personify/security">Click here</a></small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={6}>
                <Card className="mb-4">
                  <CardHeader>Delivery Method</CardHeader>
                  <CardBody>
                    <FormGroup className="mb-3">
                      <CustomInput type="radio" id="exampleCustomRadi3" name="customRadio2" label="Text/SMS (mobile only)" />
                      <CustomInput type="radio" id="exampleCustomRadio4" name="customRadio2" label="Voice Message" />
                    </FormGroup>
                    <small><strong>All codes expire after X hours</strong><br />
                    Standard message and data rates may apply</small>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4} className="ml-auto mr-auto">
                <Button tag={Link} to="/personify/kba" color="personify" size="lg" className="w-100">Send Code</Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    );
  }
}

export default PersonifySecurity;
